module.exports = __webpack_public_path__ + "img/info_btn.01104159.png";